export default __webpack_public_path__ + "static/media/Badges.b3aaf223.svg";